var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoMark(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 75,
    viewBox: "0 0 75 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dii_4558_2055)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4558_2055)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 7.14286,
    y: 4.28564,
    width: 60,
    height: 60,
    rx: 14.2857,
    fill: "url(#paint0_radial_4558_2055)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7.14286,
    y: 4.28564,
    width: 60,
    height: 60,
    rx: 14.2857,
    fill: "url(#paint1_radial_4558_2055)",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7.14286,
    y: 4.28564,
    width: 60,
    height: 60,
    rx: 14.2857,
    fill: "url(#paint2_radial_4558_2055)",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_4558_2055)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.2515 25.6366C17.2514 17.0083 15.3268 13.6834 27.7163 14.3739H30.3657C34.5746 14.374 34.5876 15.4857 35.8677 17.2743L38.562 21.1659C39.1459 21.9876 39.1687 22.0116 40.1567 22.0116H45.5015C53.5184 22.0116 55.9662 24.646 55.9663 33.2743V35.577C53.9725 33.8821 51.3917 32.8574 48.5718 32.8573C46.3746 32.8573 44.3223 33.4795 42.5796 34.5555H22.6187C21.2713 34.5555 19.968 34.9181 18.8228 35.619C18.2391 35.9573 17.7454 36.3926 17.2515 36.8758V25.6366Z",
    fill: "#89BAFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.2515 25.6366C17.2514 17.0083 15.3268 13.6834 27.7163 14.3739H30.3657C34.5746 14.374 34.5876 15.4857 35.8677 17.2743L38.562 21.1659C39.1459 21.9876 39.1687 22.0116 40.1567 22.0116H45.5015C53.5184 22.0116 55.9662 24.646 55.9663 33.2743V35.577C53.9725 33.8821 51.3917 32.8574 48.5718 32.8573C46.3746 32.8573 44.3223 33.4795 42.5796 34.5555H22.6187C21.2713 34.5555 19.968 34.9181 18.8228 35.619C18.2391 35.9573 17.7454 36.3926 17.2515 36.8758V25.6366Z",
    fill: "url(#paint3_radial_4558_2055)",
    fillOpacity: 0.6
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.5715 22.9082C53.5279 22.9082 54.5242 27.8369 54.7873 31.0527V32.0234C42.8576 32.0461 28.0945 32.2391 18.5715 32.1426V30.7139C18.8158 27.5207 19.5937 22.9082 25.55 22.9082H47.5715Z",
    fill: "#FEEBC2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.5712 24.3369C53.5277 24.3369 53.8287 28.2773 54.0918 31.4932L54.2822 34.3896C52.6012 33.417 50.6517 32.8574 48.5712 32.8574C42.2627 32.8574 37.1425 37.9776 37.1425 44.2861C37.1426 46.6718 37.8761 48.8867 39.1279 50.7197H24.8544C23.727 50.7197 22.6557 50.3804 21.6787 49.7236C20.9459 49.2481 20.288 48.5916 19.7431 47.7764C18.6721 46.1232 18.1648 44.0841 18.3339 42.0459L19.0292 31.4707C19.2735 28.2775 19.5933 24.3369 25.5498 24.3369H47.5712ZM54.7529 41.5205L47.0859 49.1885C46.6517 49.6341 45.9203 49.634 45.4746 49.1885L41.371 45.0859C40.9254 44.6403 40.9256 43.9203 41.371 43.4746C41.8168 43.0289 42.5367 43.0289 42.9824 43.4746L46.2851 46.7656L54.1484 38.9033C54.2699 38.7818 54.4122 38.6939 54.5634 38.6387L54.7529 41.5205Z",
    fill: "#FAC766"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.4791 28.1055C50.6964 28.1055 51.8732 28.4357 52.9078 29.0732C53.6788 29.513 54.3486 30.107 54.9166 30.8545L55.2409 31.3379C56.1969 32.7395 56.6485 34.4224 56.568 36.127C54.5063 34.106 51.6848 32.8575 48.5719 32.8574C42.2633 32.8574 37.1432 37.9776 37.1432 44.2861C37.1433 48.2028 39.1173 51.6603 42.1237 53.7197H24.9684C18.5368 53.7197 18.3193 51.976 17.7311 48.207L17.1774 41.0391V36.5264C16.9948 34.5477 17.5424 32.5688 18.6989 30.9639C19.2872 30.1724 19.9975 29.5349 20.7887 29.0732C21.8438 28.4356 23.001 28.1055 24.2184 28.1055H49.4791ZM54.1491 38.9033C54.5948 38.4576 55.3147 38.4576 55.7604 38.9033C56.2057 39.3491 56.206 40.0691 55.7604 40.5146L47.0856 49.1885C46.6513 49.6342 45.92 49.6342 45.4743 49.1885L41.3717 45.0859C40.926 44.6402 40.926 43.9203 41.3717 43.4746C41.8174 43.0289 42.5373 43.0289 42.983 43.4746L46.2858 46.7656L54.1491 38.9033Z",
    fill: "#1E79F7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.4791 28.1055C50.6964 28.1055 51.8732 28.4357 52.9078 29.0732C53.6788 29.513 54.3486 30.107 54.9166 30.8545L55.2409 31.3379C56.1969 32.7395 56.6485 34.4224 56.568 36.127C54.5063 34.106 51.6848 32.8575 48.5719 32.8574C42.2633 32.8574 37.1432 37.9776 37.1432 44.2861C37.1433 48.2028 39.1173 51.6603 42.1237 53.7197H24.9684C18.5368 53.7197 18.3193 51.976 17.7311 48.207L17.1774 41.0391V36.5264C16.9948 34.5477 17.5424 32.5688 18.6989 30.9639C19.2872 30.1724 19.9975 29.5349 20.7887 29.0732C21.8438 28.4356 23.001 28.1055 24.2184 28.1055H49.4791ZM54.1491 38.9033C54.5948 38.4576 55.3147 38.4576 55.7604 38.9033C56.2057 39.3491 56.206 40.0691 55.7604 40.5146L47.0856 49.1885C46.6513 49.6342 45.92 49.6342 45.4743 49.1885L41.3717 45.0859C40.926 44.6402 40.926 43.9203 41.3717 43.4746C41.8174 43.0289 42.5373 43.0289 42.983 43.4746L46.2858 46.7656L54.1491 38.9033Z",
    fill: "url(#paint4_radial_4558_2055)",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.4791 28.1055C50.6964 28.1055 51.8732 28.4357 52.9078 29.0732C53.6788 29.513 54.3486 30.107 54.9166 30.8545L55.2409 31.3379C56.1969 32.7395 56.6485 34.4224 56.568 36.127C54.5063 34.106 51.6848 32.8575 48.5719 32.8574C42.2633 32.8574 37.1432 37.9776 37.1432 44.2861C37.1433 48.2028 39.1173 51.6603 42.1237 53.7197H24.9684C18.5368 53.7197 18.3193 51.976 17.7311 48.207L17.1774 41.0391V36.5264C16.9948 34.5477 17.5424 32.5688 18.6989 30.9639C19.2872 30.1724 19.9975 29.5349 20.7887 29.0732C21.8438 28.4356 23.001 28.1055 24.2184 28.1055H49.4791ZM54.1491 38.9033C54.5948 38.4576 55.3147 38.4576 55.7604 38.9033C56.2057 39.3491 56.206 40.0691 55.7604 40.5146L47.0856 49.1885C46.6513 49.6342 45.92 49.6342 45.4743 49.1885L41.3717 45.0859C40.926 44.6402 40.926 43.9203 41.3717 43.4746C41.8174 43.0289 42.5373 43.0289 42.983 43.4746L46.2858 46.7656L54.1491 38.9033Z",
    fill: "url(#paint5_radial_4558_2055)",
    fillOpacity: 0.6
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dii_4558_2055",
    x: 0.00000286102,
    y: -0.0000700951,
    width: 74.2857,
    height: 74.2857,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.85714
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.57143
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4558_2055"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4558_2055",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -1.42857
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.42857
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_4558_2055"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.42857
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.42857
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_innerShadow_4558_2055",
    result: "effect3_innerShadow_4558_2055"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_4558_2055",
    x: 2.85718,
    y: 5.71422,
    width: 68.0057,
    height: 68.0055,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5.71429
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.14286
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.951923 0 0 0 0 0.951923 0 0 0 0 0.951923 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4558_2055"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4558_2055",
    result: "shape"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_4558_2055",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(52.1429 45.7142) rotate(-135.591) scale(48.995)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.216346,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C6DEFF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_4558_2055",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(62.8571 4.28565) rotate(159.717) scale(70.0583)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BF97FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_4558_2055",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.8571 4.28564) rotate(116.565) scale(73.4708)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#70EAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_4558_2055",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-0.714258 -21.4291 37.7463 -1.25829 30.7147 31.4282)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0F3C80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_4558_2055",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-4.28575 18.5717 -36.2009 -8.35411 31.4286 25.7142)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#70EAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_4558_2055",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-32.1432 30.0005 -50.0802 -25.9359 53.5716 31.4286)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD676"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4558_2055"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 7.14286,
    y: 4.28564,
    width: 60,
    height: 60,
    rx: 14.2857,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoMark);
export default __webpack_public_path__ + "static/media/logo-mark.a12223e404fcdbb3f1857d4fcb424871.svg";
export { ForwardRef as ReactComponent };